import { render, staticRenderFns } from "./InterventionPublishCheckModal.vue?vue&type=template&id=83d96478"
import script from "./InterventionPublishCheckModal.vue?vue&type=script&lang=js"
export * from "./InterventionPublishCheckModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports